// Generated by purs version 0.14.3
"use strict";
var Data_ByteString = require("../Data.ByteString/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Show = require("../Data.Show/index.js");
var Network_Ethereum_Core_HexString = require("../Network.Ethereum.Core.HexString/index.js");
var Network_Ethereum_Web3_Solidity_Size = require("../Network.Ethereum.Web3.Solidity.Size/index.js");
var Node_Encoding = require("../Node.Encoding/index.js");
var BytesN = function (x) {
    return x;
};
var update = function (dictKnownSize) {
    return function (v) {
        return BytesN;
    };
};
var unBytesN = function (dictKnownSize) {
    return function (v) {
        return v;
    };
};
var showBytesN = function (dictKnownSize) {
    return new Data_Show.Show(function (v) {
        return Data_Show.show(Network_Ethereum_Core_HexString.showHexString)(Data_Maybe.fromJust()(Network_Ethereum_Core_HexString.mkHexString(Data_ByteString.toString(v)(Node_Encoding.Hex.value))));
    });
};
var proxyBytesN = function (dictKnownSize) {
    return Data_ByteString.empty;
};
var fromByteString = function (dictKnownSize) {
    return function (v) {
        return function (bs) {
            var $12 = !(Data_ByteString.length(bs) <= Network_Ethereum_Web3_Solidity_Size.sizeVal(dictKnownSize)(Network_Ethereum_Web3_Solidity_Size.DLProxy.value));
            if ($12) {
                return Data_Maybe.Nothing.value;
            };
            return Data_Maybe.Just.create(bs);
        };
    };
};
var eqBytesN = Data_ByteString.eqByteString;
module.exports = {
    unBytesN: unBytesN,
    proxyBytesN: proxyBytesN,
    update: update,
    fromByteString: fromByteString,
    eqBytesN: eqBytesN,
    showBytesN: showBytesN
};
